import { SelectableItem } from '../selectable-item';
import { MembersButton } from '../members-button';
import { Box, CircularProgress } from '@mui/material';

import { ISelectableActionItem } from './types';

import { styles } from './styles';

import DeleteIcon from 'assets/icons/new/selection/recycle-bin.svg';

export const SelectableActionItem = ({
  membersButtonProps,
  isDeleting,
  onDelete,
  ...rest
}: ISelectableActionItem) => {
  return (
    <SelectableItem {...rest}>
      <Box sx={styles.container}>
        {onDelete &&
          (isDeleting ? (
            <CircularProgress />
          ) : (
            <DeleteIcon
              style={styles.delete}
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            />
          ))}
        <MembersButton {...membersButtonProps} />
      </Box>
    </SelectableItem>
  );
};
